import { Button } from "../Button/Button";
import { PlayIcon } from "../icons/PlayIcon";

export function PlayButton({
  className,
  onClick,
  disabled,
}: {
  className?: string;
  onClick?: () => void;
  disabled?: boolean;
}) {
  return (
    <Button
      className={className}
      onClick={onClick}
      variant="primary"
      shape="play"
      ariaLabel="Play"
      disabled={disabled}
    >
      <PlayIcon />
    </Button>
  );
}
